import { createSelector } from '@reduxjs/toolkit';
import type { ImageProps } from 'src/components/GallerySwiper/types';
import { getFromImmutableStateCompatible } from 'src/utils/immutableUtils';

const getImages = (state): ImageProps[] => state.get('images')?.toJS();
export const _getHotelImages = createSelector(
  getImages,
  (images) =>
    images &&
    images.map(({ smallImage, thumbImage, thumbImageX2, fullImage, id }) => ({
      id,
      smallImage,
      thumbImage,
      thumbImageX2,
      fullImage,
    })),
);

export const getHotelImages = getFromImmutableStateCompatible(_getHotelImages);
